import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { AppProvider } from './redux/AppContext';
import { Provider } from 'react-redux';
import store from './redux/store';
import { TokenProvider } from './context/TokenContext'; 

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <AppProvider>
      <TokenProvider> {/* Wrap your app with TokenProvider for memory tokens */}
        <App />
      </TokenProvider>
    </AppProvider>
  </Provider>
);
